/* eslint-disable react/jsx-key */
import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
// @mui
import { Stack, Box, Table, TableBody, TableContainer, Typography } from '@mui/material';
import { NotFound } from '../../../components/empty-content';
import { TableHeadCustom } from '../../../components/table';
import ScriptTableRow from './ScriptTableRow';
import { SavedCallScriptViewer } from '../../../components/savedCallScript';

// ------------------------------------------------------------------

const scriptTableLabels = [
    { id: 'created_at', label: 'Date', align: 'left' },
    { id: 'name', label: 'Script Name', align: 'left' },
    { id: 'actions', label: '', align: 'right' }
];

export default function LeadDetailCallScript({ leadDetail }) {
    const formData = leadDetail && leadDetail?.form_submissions && [...leadDetail?.form_submissions]?.sort((a, b) => {
        const createdAtA = moment(b.created_at, 'DD-MM-YYYY HH:mm:ss.SSSSSSZ');
        const createdAtB = moment(a.created_at, 'DD-MM-YYYY HH:mm:ss.SSSSSSZ');
        return createdAtA.isBefore(createdAtB) ? -1 : 1;
    });
    const [formId, setFormId] = useState('');
    const [submissionId, setSubmissionId] = useState('');
    const [viewerOpen, setViewerOpen] = useState(false);

    const handleOpenViewer = (formIdParam, id) => {
        setFormId(formIdParam);
        setSubmissionId(id);
        setViewerOpen(true);
    };

    const handleCloseViewer = () => {
        setViewerOpen(false);
        setFormId('');
        setSubmissionId('');
    };

    return (
        <Stack>
            <Box sx={{ p: 2 }}>
                {formData?.length > 0 && (
                    <Box>
                        {/* Header */}
                        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography variant="subtitle2" sx={{ color: '#637381', fontWeight: 600 }}>
                                {formData.length} submission{formData.length !== 1 ? 's' : ''}
                            </Typography>
                        </Box>

                        <TableContainer
                            sx={{
                                borderRadius: '12px',
                                border: '1px solid rgba(145, 158, 171, 0.16)',
                                overflow: 'hidden',
                            }}
                        >
                            <Table sx={{ minWidth: { xs: 'auto', sm: 'auto' } }}>
                                <TableHeadCustom
                                    headLabel={scriptTableLabels}
                                    rowCount={formData.length}
                                    type="LeadDetailCallScript"
                                />
                                <TableBody>
                                    {formData.map((row, index) => (
                                        <ScriptTableRow
                                            key={row.id || index}
                                            row={row}
                                            onOpenDetailSection={handleOpenViewer}
                                        />
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}
                {formData?.length === 0 && <NotFound />}
            </Box>

            {/* Full-screen Saved Call Script Viewer */}
            {viewerOpen && (
                <SavedCallScriptViewer
                    open={viewerOpen}
                    onClose={handleCloseViewer}
                    formId={formId}
                    submissionId={submissionId}
                    leadDetail={leadDetail}
                />
            )}
        </Stack>
    );
}

LeadDetailCallScript.propTypes = {
    leadDetail: PropTypes.any,
};